declare const bootstrap: any;

export const openEsignatureModal = (planId: number) => {
  const eSignatureModal = new bootstrap.Modal(
    document.getElementById(`esignature-modal-${planId}`)
  );
  eSignatureModal && eSignatureModal.show();
};
